const initial = Object.freeze({
    isInitial: true,
    isStart: false,
    isSuccess: false,
    isError: false,
    isNotFound: false
});

const start = Object.freeze({
    isInitial: false,
    isStart: true,
    isSuccess: false,
    isError: false,
    isNotFound: false
});

const success = Object.freeze({
    isInitial: false,
    isStart: false,
    isSuccess: true,
    isError: false,
    isNotFound: false
});

const error = Object.freeze({
    isInitial: false,
    isStart: false,
    isSuccess: false,
    isError: true,
    isNotFound: false

});

const notFound = Object.freeze({
    isInitial: false,
    isStart: false,
    isSuccess: false,
    isError: true,
    isNotFound: true
});

export {
    initial,
    start,
    success,
    error,
    notFound
};



// WEBPACK FOOTER //
// ./src/universal/tripboard/loading-state.js